import React from 'react';
import { useTranslation } from 'react-i18next';

import { Duration } from '@client/components/price/Range/Duration';
import { CNsDuration, type EDurationTypes } from '@common/types';

type TPeriodicPaymentProps = {
  disabled: boolean;
  canBePeriodic: boolean;
  durationTypes: (keyof typeof EDurationTypes)[];
  prefix?: string[];
  namespace?: string;
};

export const PeriodicPayment: React.FC<TPeriodicPaymentProps> = (props) => {
  const { t } = useTranslation();

  const {
    disabled,
    canBePeriodic = false,
    durationTypes = [],
    prefix = [],
    namespace = CNsDuration,
  } = props;

  return canBePeriodic ? (
    <Duration
      label={t('price.duration')}
      disabled={disabled}
      prefix={prefix}
      namespace={namespace}
      exclude={['HOUR', 'FOREVER']}
      required={true}
      durationTypes={durationTypes}
    />
  ) : null;
};
